import React from "react";
import "../components.css";


export default function DisplayTable ({ label = "Label", width = "25vw", height = "25vh", backgroundColor = "red", headerRow = ["1", "2", "3"], table = [["2", "2", "3"], ["4", "5", "6"]] }) {
    const style = {
        width: width,
        height: height,
    }

    return (
        <div className="tile" style={style}>
            <div className="tileTable" style={Object.assign({}, {backgroundColor: backgroundColor})}>
                <h1>{label}</h1>
                <table>
                    <tr>
                        {headerRow.map((col) => (
                            <th>{col}</th>
                        ))}
                    </tr>
                    {table.map((row) => (
                        <tr>
                            {row.map((col) => (
                                <td>{col}</td>
                            ))}
                        </tr>
                    ))}
                </table>
            </div>
        </div>
    )
}